import { List } from "@mui/material";
import * as React from "react";
import { ListProps } from "./types";

import "./styles.scss";

const CustomList = ({
  component,
  children,
  isBulletsList,
}: ListProps): React.JSX.Element => {
  const className = isBulletsList ? "scd-list scd-list-style" : "scd-list";

  return (
    <List
      component={component}
      classes={{
        root: `${className}`,
      }}
    >
      {children}
    </List>
  );
};

export default CustomList;
